<script>

var localForage = require("localforage");

export default {
  name: "galekloader",
  loadJWT: async function(key) {
	var res = await localForage.getItem(key).then(function(value) {
    		// This code runs once the value has been loaded
    		// from the offline store.
    		//console.log(value);
		return value;
	}).catch(function(err) {
    		// This code runs if there were any errors
    		console.log(err);
	});
	return res;
  },
  saveJWT: async function(key, value) {
	var res = await localForage.setItem(key, value).then(function (value) {
    		// Do other things once the value has been saved.
    		//console.log(value);
		return value;
	}).catch(function(err) {
    		// This code runs if there were any errors
    		console.log(err);
	});
	return res;
  },
  cleanJWT: async function() {
	var res = await localForage.clear().then(function() {
    		// Run this code once the database has been entirely deleted.
    		console.log('Database is now empty.');
		return;
	}).catch(function(err) {
    		// This code runs if there were any errors
    		console.log(err);
	});
	return res;
  },
}

</script>



// WEBPACK FOOTER //
// src/components/Storage.vue